import { uniqBy } from "../../common/helpers";
import { Fields, SelectionType } from "./select.typings";

export const mapToSingleItem = <T>(item: SelectionType<T>): T | null => {
  if (Array.isArray(item)) {
    return item.length > 0 ? item[0] : null;
  }
  return item;
};

export const mapToAnArrayOfItems = <T>(items: SelectionType<T>): T[] =>
  Array.isArray(items) ? items : items ? [items] : [];

export const mapToNormalizeSelectedItems = <T>(
  selectedItems: SelectionType<T>,
  singleSelect: boolean,
  idField: Fields<T>,
  readOnlyItems?: T[]
): T[] => {
  // insure the T type is an array.
  const selectedItemsAsArray = Array.isArray(selectedItems) ? selectedItems : selectedItems ? [selectedItems] : [];
  // combine selected and readonly items in one list.
  const allItems = uniqBy([...(readOnlyItems ?? []), ...selectedItemsAsArray], idField);

  // single select ignore the rest of list.
  return singleSelect && allItems?.length > 1 ? [allItems[0]] : allItems;
};
